import validateRange from "./validate-range.api";
import moveSn from "./move-sn.api";
import getBranchList from "./get-branch-list.api";

const managementSnApi = {
  validateRange,
  moveSn,
  getBranchList,
};

export default managementSnApi;
